import { IntegrationServices } from '@sequencehq/api/commonEnums'
import { IntegrationId } from './types'

export const storeEntityLink = (
  integrationIds: IntegrationId[],
  service: IntegrationServices,
  id: string
): IntegrationId[] => {
  return [
    // PUT /products upserts every entry as a product link, so a round-tripped
    // LEDGER_ACCOUNT entry would overwrite that service's item link.
    ...integrationIds.filter(
      integrationId =>
        integrationId.service !== service &&
        integrationId.externalEntityType !== 'LEDGER_ACCOUNT'
    ),
    { service, id }
  ]
}
